import apiService from "./apiService";
import { SetSmartFormQuestionAnswerDTO } from "@sizdevteam1/funjoiner-web-shared/components/QuestionPipeline/QuestionPipelineVm";
import { SmartFormDTO } from "@sizdevteam1/funjoiner-web-shared/interfaces/smart-forms";

export type SmartFormStatus = "COMPLETE" | "INCOMPLETE" | "AWAITING_APPROVAL";

export type SmartFormVirtualSignatureSettingsDTO = {
  instructions: string;
  description: string;
};

export type SmartFormVirtualSignatureDTO = {
  id: string;
  signed_at: string;
  sign_value: string;
  is_expired: boolean;
  is_signed: boolean;
};

export type SmartFormQuestionAnswerBaseDTO = {
  employee_id: number | undefined;
};

export type TextQuestionInputType = "TEXT_AREA" | "INPUT";

export interface StudentSmartFormsDTO {
  student_id: number;
  smart_forms: SmartFormDTO[];
}
export const getAll = (): Promise<SmartFormDTO[]> => {
  return apiService.get("/customer_api/v2/smart_forms/");
};

export type SetAnswersDTO = {
  smart_form_template_id: string;
  student_id: number;
  answers: SetSmartFormQuestionAnswerDTO[];
  virtual_signature: string | null;
};
export const setAnswers = (dto: SetAnswersDTO): Promise<SmartFormDTO> => {
  return apiService.post("/customer_api/v2/smart_forms/set_answers", {
    data: dto,
  });
};
export const skip = (
  smart_form_template_id: string,
  student_id: number,
): Promise<SmartFormDTO> => {
  return apiService.post("/customer_api/v2/smart_forms/skip", {
    data: {
      smart_form_template_id,
      student_id,
    },
  });
};
